var map = {
	"./company_info/lt/questions.json": "add3",
	"./data_collection/lt/questions.json": "8664",
	"./data_usage_purpose/lt/questions.json": "58ad",
	"./general_info/lt/questions.json": "6475",
	"./it/lt/questions.json": "3297",
	"./marketing/lt/questions.json": "45be",
	"./surveillance/lt/questions.json": "8693"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "43e0";